export class CanonicalJsonError extends TypeError {
    constructor(message) {
        super(message);
        this.name = "CanonicalJsonError";
    }
}
const SURROGATE_CODE_UNIT = /[\uD800-\uDFFF]/;
// eslint-disable-next-line no-control-regex -- JSON 必须识别并转义 U+0000 至 U+001F 控制字符。
const ESCAPED_OR_SURROGATE_CODE_UNIT = /["\\\u0000-\u001F\uD800-\uDFFF]/;
function encodeString(value) {
    if (!ESCAPED_OR_SURROGATE_CODE_UNIT.test(value))
        return '"' + value + '"';
    assertUnicodeScalarSequence(value);
    return JSON.stringify(value);
}
function encode(value, ancestors) {
    if (value === null)
        return "null";
    if (typeof value === "boolean")
        return value ? "true" : "false";
    if (typeof value === "string") {
        return encodeString(value);
    }
    if (typeof value === "number") {
        if (!Number.isFinite(value))
            throw new CanonicalJsonError("数值必须是有限 JSON number");
        return String(value);
    }
    if (typeof value !== "object") {
        throw new CanonicalJsonError("值不是有限、无歧义的 JSON 数据");
    }
    const prototype = Object.getPrototypeOf(value);
    if (!Array.isArray(value) && prototype !== Object.prototype && prototype !== null) {
        throw new CanonicalJsonError("JSON object 必须使用普通或 null prototype");
    }
    if (ancestors.includes(value))
        throw new CanonicalJsonError("JSON 数据包含循环引用");
    ancestors.push(value);
    try {
        if (Array.isArray(value)) {
            let result = "[";
            for (let index = 0; index < value.length; index += 1) {
                if (!Object.hasOwn(value, index)) {
                    throw new CanonicalJsonError("JSON array 不能包含稀疏空位");
                }
                if (index)
                    result += ",";
                result += encode(value[index], ancestors);
            }
            return result + "]";
        }
        const object = value;
        const keys = Object.keys(object);
        if (keys.length > 16) {
            keys.sort();
        }
        else {
            // 小对象使用有界插入排序，避免通用排序的临时工作区；仍按 UTF-16 比较键。
            for (let index = 1; index < keys.length; index += 1) {
                const key = keys[index];
                let insertion = index;
                while (insertion > 0 && keys[insertion - 1] > key) {
                    keys[insertion] = keys[insertion - 1];
                    insertion -= 1;
                }
                keys[insertion] = key;
            }
        }
        let result = "{";
        for (let index = 0; index < keys.length; index += 1) {
            const key = keys[index];
            if (index)
                result += ",";
            result += encodeString(key) + ":" + encode(object[key], ancestors);
        }
        return result + "}";
    }
    finally {
        ancestors.pop();
    }
}
export function canonicalJson(value) {
    return encode(value, []);
}
function assertUnicodeScalarSequence(value) {
    const firstSurrogate = value.search(SURROGATE_CODE_UNIT);
    if (firstSurrogate < 0)
        return;
    for (let index = firstSurrogate; index < value.length; index += 1) {
        const code = value.charCodeAt(index);
        if (code >= 0xd800 && code <= 0xdbff) {
            const next = value.charCodeAt(index + 1);
            if (!(next >= 0xdc00 && next <= 0xdfff)) {
                throw new CanonicalJsonError("RFC 8785 字符串不能包含孤立 UTF-16 surrogate");
            }
            index += 1;
        }
        else if (code >= 0xdc00 && code <= 0xdfff) {
            throw new CanonicalJsonError("RFC 8785 字符串不能包含孤立 UTF-16 surrogate");
        }
    }
}
//# sourceMappingURL=canonical-json.js.map